export const pendingInvoicesExcelColumnDefs = [
	{
		header: "Kunde",
		accessor: "companyDisplayName",
		type: "string",
	},
	{
		header: "Projekt-Id",
		accessor: "projectNumberWithPhaseNumber",
		type: "string",
	},
	{
		header: "Titel",
		accessor: "projectTitle",
		type: "string",
	},
	{
		header: "Rechnungsbetrag (netto)",
		accessor: "invoiceTotalCents",
		type: "currency",
	},
	{
		header: "Leistungszeitraum",
		accessor: "deliveryPeriodFormatted",
		type: "string",
	},
	{
		header: "Kommentar",
		accessor: "comment",
		type: "string",
	},
];